import { Navbar, Nav, Container, Image, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";


const Navigation = ({ userEmail, onLogout }) => (
  <Navbar expand="lg" className="custom-navbar">
    <Container>
      <Navbar.Brand as={Link} to="/">
        <Image
          src="https://sitemobili.s3.amazonaws.com/logo-mobili_v1.png"
          alt="Mobili Logo"
          className="navbar-logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Nav.Link as={Link} to="/">Dashboard</Nav.Link>
          <Nav.Link as={Link} to="/escalation">Escalation</Nav.Link>
          <Nav.Link as={Link} to="/inventory">Inventário</Nav.Link>
          <Nav.Link as={Link} to="/monitor">Alertas em Tempo Real</Nav.Link>

        </Nav>

        <Dropdown align="end">
  <Dropdown.Toggle
    style={{
      backgroundColor: "#ff7f00",
      color: "#fff",
      border: "1px solid #ff7f00",
      fontWeight: "500",
      fontSize: "0.85rem",
      padding: "4px 12px",
      borderRadius: "4px",
      lineHeight: "1.2"
    }}
  >
    {userEmail}
  </Dropdown.Toggle>

  <Dropdown.Menu
    style={{
      minWidth: "180px",
      padding: "4px 0",
      fontSize: "0.82rem",
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
    }}
  >
    <Dropdown.Item
      disabled
      className="d-flex align-items-center gap-2 text-muted py-2 px-3"
    >
      <span style={{ fontSize: "1rem" }}>⚙️</span>
      Configurações (em breve)
    </Dropdown.Item>

    <div style={{ height: "1px", backgroundColor: "#ddd", margin: "4px 12px" }} />

    <Dropdown.Item
      onClick={onLogout}
      className="d-flex align-items-center gap-2 text-danger py-2 px-3"
    >
      <span style={{ fontSize: "1rem" }}>🔒</span>
      Sair
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>



      </Navbar.Collapse>
    </Container>
  </Navbar>
);

export default Navigation;
